import * as React from 'react';
import {useState} from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import { Link } from 'react-router-dom';

export default function NavBar({toggleSidebar, isLogin}) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar 
        position="static"
        sx={{
          background: 'linear-gradient(to right, #af2735, #af2735 7.69%, white 7.69%, white 15.38%, #af2735 15.38%, #af2735 23.07%, white 23.07%, white 30.76%, #af2735 30.76%, #af2735 38.45%, white 38.45%, white 46.14%, #af2735 46.14%, #af2735 53.83%, white 53.83%, white 61.52%, #af2735 61.52%, #af2735 69.21%, white 69.21%, white 76.9%, #af2735 76.9%, #af2735 84.59%, white 84.59%, white 92.28%, #af2735 92.28%, #af2735 100%)',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '30%',
            height: '100%',
            background: '#112864',
            zIndex: 1
          }
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ 
              mr: 2,
              color: 'white',
              zIndex: 2 
            }}
            onClick={toggleSidebar}
          >
            <MenuIcon />
          </IconButton>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              textAlign: 'center', 
              flexGrow: 1,
              color: 'white',
              textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
              fontWeight: 800,
              fontSize: '1.5rem',
              padding: '5px'
            }}
          >
            Presidential Election Prediction
          </Typography>
          {!isLogin ? 
            <Button 
              color="inherit" 
              component={Link} 
              to="/login"
              sx={{ 
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              Login
            </Button> 
            : 
            <IconButton sx={{ p: 0, zIndex: 2 }}>
              <Avatar alt="User" />
            </IconButton>
          }
        </Toolbar>
      </AppBar>
    </Box>
  );
}
